'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { BlocksRenderer, type BlocksContent } from '@strapi/blocks-react-renderer';
import Typography from '@mui/material/Typography';
export default function RichText(t0) {
  const $ = _c(3);
  const {
    content
  } = t0;
  if (!content) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      image: _temp,
      paragraph: _temp3,
      heading: _temp11,
      list: _temp14
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== content) {
    t2 = <BlocksRenderer content={content} blocks={t1} />;
    $[1] = content;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
function _temp14(t0) {
  const {
    children: children_1,
    format
  } = t0;
  if (format === "ordered") {
    return <ol><Typography variant="body-base" component="p" sx={{
        whiteSpace: "pre-wrap",
        color: _temp12
      }}>{children_1}</Typography></ol>;
  }
  return <ul><Typography variant="body-base" component="p" sx={{
      whiteSpace: "pre-wrap",
      color: _temp13
    }}>{children_1}</Typography></ul>;
}
function _temp13(theme_8) {
  return theme_8.colors.text.secondary;
}
function _temp12(theme_7) {
  return theme_7.colors.text.secondary;
}
function _temp11(t0) {
  const {
    children: children_0,
    level
  } = t0;
  switch (level) {
    case 1:
      {
        return <Typography variant="h1" sx={{
          color: _temp4
        }}>{children_0}</Typography>;
      }
    case 2:
      {
        return <Typography variant="h2" sx={{
          color: _temp5
        }}>{children_0}</Typography>;
      }
    case 3:
      {
        return <Typography variant="h3" sx={{
          color: _temp6
        }}>{children_0}</Typography>;
      }
    case 4:
      {
        return <Typography variant="h4" sx={{
          color: _temp7
        }}>{children_0}</Typography>;
      }
    case 5:
      {
        return <Typography variant="h5" sx={{
          color: _temp8
        }}>{children_0}</Typography>;
      }
    case 6:
      {
        return <Typography variant="h6" sx={{
          color: _temp9
        }}>{children_0}</Typography>;
      }
    default:
      {
        return <Typography variant="h1" sx={{
          color: _temp10
        }}>{children_0}</Typography>;
      }
  }
}
function _temp10(theme_0) {
  return theme_0.colors.text.primary;
}
function _temp9(theme_1) {
  return theme_1.colors.text.secondary;
}
function _temp8(theme_2) {
  return theme_2.colors.text.secondary;
}
function _temp7(theme_3) {
  return theme_3.colors.text.secondary;
}
function _temp6(theme_4) {
  return theme_4.colors.text.secondary;
}
function _temp5(theme_5) {
  return theme_5.colors.text.secondary;
}
function _temp4(theme_6) {
  return theme_6.colors.text.primary;
}
function _temp3(t0) {
  const {
    children
  } = t0;
  return <Typography variant="body-base" component="p" sx={{
    whiteSpace: "pre-wrap",
    color: _temp2
  }}>{children}</Typography>;
}
function _temp2(theme) {
  return theme.colors.text.secondary;
}
function _temp(t0) {
  const {
    image
  } = t0;
  return <Image src={image.url} width={image.width} height={image.height} alt={image.alternativeText || ""} />;
}